import { render, staticRenderFns } from "./resumen-progreso.vue?vue&type=template&id=11d0d65a&scoped=true&"
import script from "./resumen-progreso.vue?vue&type=script&lang=ts&"
export * from "./resumen-progreso.vue?vue&type=script&lang=ts&"
import style0 from "./resumen-progreso.vue?vue&type=style&index=0&id=11d0d65a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0d65a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressLinear,VRow,VSpacer})
